import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import success from '@/assets/success.svg';

function EditEmailLinkSent() {
    const nav = useNavigate();

    return <div>

        <div className={'complete-container'}>
            <div className={'complete-container-success'}>
                <img src={success} />
            </div>
            <div className={'complete-container-text'}>Verification Link Sent!</div>
            <div className={'complete-container-subtext'}>
                <p>Verification link has been sent via email to:</p>
                <p>email@email.com</p>
            </div>
        </div>
        <div className={'block-button-container'}>
            <button type={'button'} onClick={() => nav('../signin')} className={'btn btn-primary btn-block'}>Return to Login</button>
        </div>

    </div>
}


export default EditEmailLinkSent;